/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_After_Delta_AddedInputs */

const en_us2_workout_after_delta_added = /** @type {(inputs: Workout_After_Delta_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 more set`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 more set`);
	return /** @type {LocalizedString} */ (`${i?.count} more sets`)
	
};

const pt_br2_workout_after_delta_added = /** @type {(inputs: Workout_After_Delta_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série a mais`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 série a mais`);
	return /** @type {LocalizedString} */ (`${i?.count} séries a mais`)
	
};

const es_419_workout_after_delta_added = /** @type {(inputs: Workout_After_Delta_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie más`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 serie más`);
	return /** @type {LocalizedString} */ (`${i?.count} series más`)
	
};

const pt_pt2_workout_after_delta_added = /** @type {(inputs: Workout_After_Delta_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série a mais`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 série a mais`);
	return /** @type {LocalizedString} */ (`${i?.count} séries a mais`)
	
};

const fr_fr2_workout_after_delta_added = /** @type {(inputs: Workout_After_Delta_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série de plus`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 série de plus`);
	return /** @type {LocalizedString} */ (`${i?.count} séries de plus`)
	
};

const de_de2_workout_after_delta_added = /** @type {(inputs: Workout_After_Delta_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Satz mehr`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 Satz mehr`);
	return /** @type {LocalizedString} */ (`${i?.count} Sätze mehr`)
	
};

const it_it2_workout_after_delta_added = /** @type {(inputs: Workout_After_Delta_AddedInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 serie in più`);
	if ((i?.count === -1 || i?.count === "-1")) return /** @type {LocalizedString} */ (`1 serie in più`);
	return /** @type {LocalizedString} */ (`${i?.count} serie in più`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 more set" |
* | "-1" | "1 more set" |
* | * | "{count} more sets" |
*
* @param {Workout_After_Delta_AddedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_delta_added = /** @type {((inputs: Workout_After_Delta_AddedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Delta_AddedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_delta_added(inputs)
	if (locale === "es-419") return es_419_workout_after_delta_added(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_delta_added(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_delta_added(inputs)
	if (locale === "de-DE") return de_de2_workout_after_delta_added(inputs)
	if (locale === "it-IT") return it_it2_workout_after_delta_added(inputs)
	return en_us2_workout_after_delta_added(inputs)
});
export { workout_after_delta_added as "workout-after.delta_added" }